import React from 'react';
import additional from './openProject_grey.svg'

const OpenProject_grey = ({ isMobile }) => {
  return (
    <img width={isMobile ? "36" : "56"} height={isMobile ? "36" : "56"} src={additional} />
  )
};

export default OpenProject_grey;
